import apiClient from "./apiClient";

interface PaginationParams {
	page?: number;
	per_page?: number;
}

/**
 * Fetch all vehicle brands with optional pagination
 */
export const fetchVehicleBrands = async (
	params: PaginationParams = { page: 1, per_page: 300 },
) => {
	const response = await apiClient.get(`/vehicle/brand`, { params });
	console.log("Fetching brands:", response.data);
	return response.data;
};

/**
 * Fetch all vehicle types with optional pagination
 */
export const fetchVehicleTypes = async (
	params: PaginationParams = { page: 1, per_page: 300 },
) => {
	const response = await apiClient.get(`/vehicle/type`, { params });
	console.log("Fetching types:", response.data);
	return response.data;
};

/**
 * Fetch all vehicle models with optional pagination
 */
export const fetchVehicleModels = async (
	params: PaginationParams = { page: 1, per_page: 300 },
) => {
	const response = await apiClient.get(`/vehicle/model`, { params });
	console.log("Fetching models:", response.data);
	return response.data;
};
